// Libraries
import React from 'react';
import { Modal, Row, Form } from 'antd';
import { useAppDispatch } from '../../../store/store';

// Store
import { createOrUpdateResources } from '../../../store/redux/actions/resourcesActions';

// Types
import { ResourceType } from '../../../types/resourcesTypes';

// Components
import ButtonComponent from '../../subComponents/ButtonComponent';
import FormItemComponent from '../../subComponents/FormItemComponent';
import InputComponent from '../../subComponents/InputComponent';


type PropsType = {
  resources: ResourceType | null;
  onToggleModal: (visible: boolean) => void;
};

const ResourcesFormModal = (props: PropsType) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { resources, onToggleModal } = props;
  const [dailyCapacity, setDailyCapacity] = React.useState<number>(
    (resources?.workers ?? 0) * (resources?.hours ?? 0) * (resources?.productivity ?? 0)
  );

  const calculateDailyCapacity = (values: Partial<ResourceType>) => {
    const workers = values.workers ?? form.getFieldValue('workers') ?? resources?.workers ?? 0;
    const hours = values.hours ?? form.getFieldValue('hours') ?? resources?.hours ?? 0;
    const productivity = values.productivity ?? form.getFieldValue('productivity') ?? resources?.productivity ?? 0;

    return workers * hours * productivity;
  };

  const handleSubmit = (resource: ResourceType) => {
    if (resources?.resourceId) {
      resource.resourceId = resources.resourceId;
    }

    dispatch(createOrUpdateResources(resource));
    onToggleModal(false);
  };

  return (
    <Modal
      title={'Editar recursos'}
      open={true}
      maskClosable
      closable={false}
      keyboard={false}
      destroyOnClose={true}
      width={600}
      footer={[
        <ButtonComponent
          key={'cancel'}
          text={'Cerrar'}
          className={
            'w-32 h-8 bg-white border border-grey-dkt-300 leading-4 text-grey-dkt-700 ' +
            'hover:bg-grey-dkt-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-dkt-400'
          }
          onClick={() => onToggleModal(false)}
        />,
        <ButtonComponent
          key={'submit'}
          text={'Guardar'}
          className={
            'w-32 h-8 text-white bg-blue-dkt-400 hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
            'focus:ring-offset-2 focus:ring-blue-dkt-300 after:content-none'
          }
          onClick={() => form.submit()}
        />,
      ]}
    >
      <Form
        layout={'vertical'}
        form={form}
        initialValues={resources ?? {}}
        onFinish={handleSubmit}
        onValuesChange={(_, values) => {
          setDailyCapacity(calculateDailyCapacity(values));
        }}
      >
        <Row className={'grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-4'}>
          <FormItemComponent
            name={'workers'}
            label={'Trabajadores'}
            required={true}
            child={<InputComponent type='number' />}
          />
          <FormItemComponent
            name={'hours'}
            label={'Horas diarias'}
            required={true}
            child={<InputComponent type='number' />}
          />
          <FormItemComponent
            name={'productivity'}
            label={'Productividad (Cajas/hora)'}
            required={true}
            child={<InputComponent type='number' />}
          />
          <FormItemComponent
            name={'dailyCapacity'}
            label={'Capacidad diaria (cajas)'}
            required={false}
            child={<InputComponent type='number' readOnly disabled />}
            initialValue={dailyCapacity}
            getValueFromEvent={() => dailyCapacity}
          />
        </Row>
      </Form>
    </Modal>
  );
};

export default ResourcesFormModal;
